module.exports = __webpack_public_path__ + "img/successful-event-creation.3325508c.png";